import { cr } from "fire-wind-water/core";

class Field {
  constructor(field) {
    this.fieldInfo = field;
    const attr = [
      "tenantId",
      "fieldName",
      "displayName",
      "fieldType",
      "displayType",
      "required",
      "isSendSms",
      "fieldLevel",
      "errorMessage",
      "textLength"
    ];
    cr.each(attr, d => {
      this[d] = field[d];
    });
    this.dirty = false;
    this.invalid = true;
    this.disabled = field.disabled ? true : false;
    this.value = "";
    this.model = "";
    this.validationMessage = "";
    this.initError();
  }

  setDisabled() {
    this.disabled = true;
  }

  setEnable() {
    this.disabled = false;
  }
  initError() {
    this.error = {
      required: false,
      pattern: false,
      maxLength: false,
      number: false,
      unique: false,
      repeat: false
    };
    this.messages = {
      required: "请填写" + this.displayName,
      pattern: this.errorMessage || "请输入正确的" + this.displayName,
      unique: this.displayName + "已注册",
      repeat: this.displayName + "已存在",
      number: "请输入数字",
      maxLength: "输入长度不超过" + this.textLength
    };
    this.errorCustom = [];
  }

  setError() {
    this.invalid = false;
    this.validationMessage = "";
    for (let a in this.error) {
      this.error[a] = false;
    }
    this.error.required = false;
    this.error.pattern = false;
    this.error.maxLength = false;
    this.error.number = false;
    this.error.unique = false;
    this.error.repeat = false;
  }

  setCustomError(o) {
    this.error[o.key] = o.value || false;
    this.messages[o.key] = o.message;
    this.errorCustom.push(o);
  }

  isCustomError() {
    cr.each(this.errorCustom, d => {
      if (d.validator) {
        let inval = d.validator(this);
        this.error[d.key] = !inval;
        if (!inval) {
          this.invalid = true;
        }
      }
    });
  }
  isError() {
    this.invalid = false;
    this.validationMessage = "";
    this.isCustomError();
    cr.each(this.error, (d, t) => {
      if (d) {
        this.invalid = true;
        if (!this.validationMessage) {
          this.validationMessage = this.messages[t];
        }
      }
    });
  }
}

export { Field };
